//@flow
import type {ChatServiceType} from '..';
import type {ImageSource} from '../../';
import type {WhatsAppWebMessage} from './whatsapp';
import type {FacebookMessengerMessage} from './fb-messenger';
import type {InstagramMessage} from './instagram';
import type {WhatsAppApiMessage} from './whatsapp-api';

export * from './whatsapp';
export * from './fb-messenger';
export * from './instagram';

export type MessageType =
  | 'TEXT'
  | 'IMAGE'
  | 'VIDEO'
  | 'AUDIO'
  | 'DOCUMENT'
  | 'TEMPLATE'
  | 'REACTION'
  | 'LOCATION';

export const MESSAGE_TYPES = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  DOCUMENT: 'DOCUMENT',
  LOCATION: 'LOCATION',
};

export type MessageContent =
  | FacebookMessengerMessage
  | WhatsAppWebMessage
  | InstagramMessage;

export type RepliedMessage = {
  messageId: string,
  messageType: MessageType,
  fromMe: boolean,
  text?: string,
  messageReceivedAt: string,
};

export type MessageMetadata = {
  source: 'USER' | 'CHATBOT',
  user: {
    firstname: string,
    id: number,
    lastname: string,
    type: 'VENDOR' | 'COLLABORATOR',
  },
};

export type MessageResponse =
  | {
      fromMe: boolean,
      messageType: MessageType,
      providerMessageId: string,
      repliedMessage: RepliedMessage,
      service: 'WHATSAPP_WEB',
      message: WhatsAppWebMessage,
      receivedAt: number,
      rawReceivedAt: string,
      metadata?: MessageMetadata,
    }
  | {
      fromMe: boolean,
      messageType: MessageType,
      providerMessageId: string,
      service: 'INSTAGRAM',
      message: InstagramMessage,
      receivedAt: number,
      repliedMessage: RepliedMessage,
      rawReceivedAt: string,
      metadata?: MessageMetadata,
    }
  | {
      fromMe: boolean,
      messageType: MessageType,
      providerMessageId: string,
      service: 'FB_MESSENGER',
      message: FacebookMessengerMessage,
      receivedAt: number,
      repliedMessage: RepliedMessage,
      rawReceivedAt: string,
      metadata?: MessageMetadata,
    }
  | {
      fromMe: boolean,
      messageType: MessageType,
      providerMessageId: string,
      service: 'WHATSAPP_API',
      message: WhatsAppApiMessage,
      receivedAt: number,
      repliedMessage: RepliedMessage,
      rawReceivedAt: string,
      metadata?: MessageMetadata,
    };

export type RepliedMessageRequest = {
  messageId: string,
  messageReceivedAt: string,
  messageType: MessageType,
  text?: string,
  fileUrl?: string,
  fromMe?: boolean,
};
export type MessageRequest = {
  text?: string,
  messageType: MessageType,
  fileUrl?: string,
  repliedMessage?: RepliedMessageRequest,
};

// types to handle in the app
export type MessageMultimedia = {
  size?: number,
  mimetype?: string,
  src?: ImageSource,
  mediaId?: string,
  name?: string,
};

type ImageMessage = MessageMultimedia & {
  caption?: string,
};

export type ReactionMessage = {
  reaction: string,
  messageId: string,
  fromMe: boolean,
  id: string,
};

export type ConversationMessage = {
  id: string,
  messageType: MessageType,
  service: ChatServiceType,
  fromMe: boolean,

  isUnreachable?: boolean, // this flag for meta temp URLs

  text?: string,
  images?: ImageMessage[],
  videos?: MessageMultimedia[],
  audios?: MessageMultimedia[],
  documents?: MessageMultimedia[],
  coords?: {
    lat: number,
    lng: number,
  },
  receivedAt?: number,
  rawReceivedAt: string,
  repliedMessage?: RepliedMessage,

  metadata?: MessageMetadata,
};
